import { messageNotification } from "./functions";

export const transformResponseHandler = (resp, alert = true) => {
  if (alert && resp?.message) {
    messageNotification(resp?.message, !resp?.status ? "error" : "success");
  }

  let transformedResp = {
    status: resp.status,
    data: resp.data,
    total: resp?.data?.count,
    extraMeta: resp.extraMeta,
  };
  if (resp.access_token) {
    transformedResp.access_token = resp.access_token;
    transformedResp.refreshToken = resp.refreshToken;
  }
  return transformedResp;
};
